export default "__VITE_ASSET__CzoAEIxI__"